// Own-clip stories (stories.ts): uploads checked here and on the client.

export const STORY_PHOTO_MAX_BYTES = 6 * 1024 * 1024
export const STORY_VIDEO_MAX_BYTES = 30 * 1024 * 1024
export const STORY_VIDEO_MAX_SECONDS = 15
export const STORY_CAPTION_MAX = 120
// Poster plus the frames at about 1/3 and 2/3 of a clip.
export const STORY_SCREEN_FRAMES = 2

export const STORY_REPORT_REASONS = ['nudity', 'violence', 'harassment', 'spam', 'other'] as const
export type StoryReportReason = (typeof STORY_REPORT_REASONS)[number]

export const SCREEN_VERDICTS = [
  'ok',
  'sexual',
  'violent',
  'hateful',
  'self_harm',
  'unsafe_other',
] as const

export type StoryPostError = 'badFile' | 'tooLarge' | 'tooMany' | 'notFound'

export const STORY_REACTIONS = [
  ['fire', '🔥'],
  ['clap', '👏'],
  ['muscle', '💪'],
  ['heart', '❤️'],
  ['laugh', '😂'],
  ['target', '🎯'],
] as const
export type StoryReaction = (typeof STORY_REACTIONS)[number][0]
export const storyReactionEmoji = (r: StoryReaction) =>
  STORY_REACTIONS.find(([k]) => k === r)?.[1] ?? ''

export const STORY_REPLY_MAX = 300
// notificationHistory types.
export const STORY_REACTION_TYPE = 'storyReaction'
export const STORY_REPLY_TYPE = 'storyReply'
